const colors = {
  pureBlack: '#000',
  pureWhite: '#ffffff',
  red: '#FE576B',
  error: '#FE576B',
  // CCI Colors
  neonBlue: '#373CF5',
  royalBlue: '#3769FF',
  egyptianBlue: '#141EA5',
  aliceBlue: '#F3FAFF',
  darkOrange: '#FA9202',
  nightRider: '#333333',
  silver: '#C5C5C5',
  grey4: '#BDBDBD',
  grey: '#767676',
  gainsboro: '#E0E0E0',
  crimson: '#E50043',
}

export default colors
